export default __webpack_public_path__ + "static/media/fleas.454f53a7.png";